<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('exportAndPrint') }}
      <template #action>
        <date-picker-input
          v-model="dateRange"
          card-class="pa-3"
          color="grey lighten-3"
        />
      </template>
    </page-header>

    <div>
      <div class="mt-2 text-body-1">
        <p>{{ $t('aadenPosSupportTitle') }}</p>
      </div>

      <v-card
        v-for="item in items"
        :key="item.id"
        class="pa-6 mt-4"
        color="grey lighten-3"
        elevation="0"
      >
        <div class="d-flex align-center justify-center">
          <div>
            <div>{{ $t(item.value) }}</div>
            <div class="text-caption">
              {{ item.desc }}
            </div>
          </div>
          <v-spacer />
          <div class="d-flex">
            <v-btn
              v-if="item.reprint"
              :loading="btnLoading"
              class="grey lighten-2 mr-2"
              icon
              @click="reprint(item)"
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
            <v-btn
              v-if="item.download"
              :loading="btnLoading"
              class="grey lighten-2 mr-2"
              icon
              @click="download(item)"
            >
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
            <v-btn
              v-if="item.sendEmail"
              :loading="btnLoading"
              class="grey lighten-2 mr-2"
              icon
              @click="sendEmail(item)"
            >
              <v-icon>
                mdi-email
              </v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
      <a ref="downloadfile" />
    </div>
    <v-dialog
      v-model="selectedDish"
      max-width="600px"
    >
      <v-card>
        <div class="d-flex align-center pa-4">
          <div class="text-h3 font-weight-bold">
            {{ $t('ItemStatistics') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="selectedDish = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          class="pa-4"
        >
          <h3>
            {{ $t('chooseOtherConditions') }}
          </h3>
          <div>
            <div class="text-overline">
              {{ $t('chooseNeedInclude') }}{{ $t('dishCategoryType') }}
            </div>
            <div>
              <v-select
                v-model="selectFilter.selectCategoryTypeIds"
                :items="dishCategoryTypeList"
                :menu-props="{overflowY: true, outlined: true, contentClass: 'elevation-2 ikRounded', nudgeBottom: '64px'}"
                :placeholder="$t('TaxType')"
                dense
                hide-details
                item-text="_langsname"
                item-value="id"
                multiple
                outlined
                @click:clear="$emit('clear')"
              >
                <template
                  #selection=" { index}"
                >
                  <span
                    v-if="index == 0"
                    class="grey--text text-caption"
                  >
                    {{ $t('TaxType') }} (+{{ selectFilter.selectCategoryTypeIds.length || 1 }})
                  </span>
                </template>
              </v-select>
            </div>

            <div
              class="text-overline"
            >
              {{ $t('chooseNeedInclude') }}{{ $t('dishCategory') }}
            </div>
            <v-select
              v-model="selectFilter.selectCategoryIds"
              :items="dishCategoryList"
              :menu-props="{overflowY: true, outlined: true, contentClass: 'elevation-2 ikRounded', nudgeBottom: '64px'}"
              :placeholder="$t('dishCategory')"
              dense
              hide-details
              item-text="_langsname"
              item-value="id"
              multiple
              outlined
              @click:clear="$emit('clear')"
            >
              <template
                #selection=" { index}"
              >
                <span
                  v-if="index == 0"
                  class="grey--text text-caption"
                >
                  {{ $t('dishCategory') }} (+{{ selectFilter.selectCategoryIds.length || 1 }})
                </span>
              </template>
            </v-select>

            <div class="text-overline">
              {{ $t('chooseNotNeedInclude') }}{{ $t('dishAttribute') }}
            </div>
            <v-select
              v-model="selectFilter.selectHideAttributeIds"
              :items="hideAttributeList"
              :menu-props="{overflowY: true, outlined: true, contentClass: 'elevation-2 ikRounded', nudgeBottom:'64px'}"
              :placeholder="$t('dishAttribute')"
              dense
              hide-details
              item-text="name"
              item-value="id"
              multiple
              outlined
              @click:clear="$emit('clear')"
            >
              <template
                #selection=" { index}"
              >
                <span
                  v-if="index == 0"
                  class="grey--text text-caption"
                >
                  {{ $t('dishAttribute') }} (+{{ selectFilter.selectHideAttributeIds.length || 1 }})
                </span>
              </template>
            </v-select>
            <div
              class="pa-1 flex-grow-1"
            >
              <p class="my-2">
                {{ $t('numberOfDishes', { filterListLength: filterDishStatisticList?.length }) }}
              </p>
            </div>

            <div>
              <v-btn
                block
                class="mt-2"
                outlined
                style="background-color: white; color: black"
                @click="handleClear"
              >
                {{ $t('cleanSelect') }}
              </v-btn>
            </div>
            <div
              v-if="dishStatisticPrintOrSendEmail === 'send'"
              class="mt-4"
            >
              <send-to-email-button
                :disabled="filterDishStatisticList.length<=0"
                :dish-statistic-loading="dishStatisticLoading"
                @click="printOrSendMail('sendToMail')"
              />
            </div>
            <div
              v-if="dishStatisticPrintOrSendEmail === 'print'"
              class="mt-4"
              style="display: grid;grid-gap: 16px;grid-template-columns: repeat(2, 1fr)"
            >
              <div>
                <v-btn
                  outlined
                  width="100%"
                  @click="printOrSendMail('printWithCode')"
                >
                  {{ $t('printByDishNumber') }}
                </v-btn>
              </div>
              <div>
                <v-btn
                  outlined
                  width="100%"
                  @click="printOrSendMail('print')"
                >
                  {{ $t('print') }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="selectedZbonDialog"
      max-width="600px"
    >
      <v-card class="pa-4 py-4">
        <div class="d-flex align-center">
          <div class="text-h3 font-weight-bold">
            {{ $t('ZBonList') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="selectedZbonDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center">
          <h3>{{ $t('searchResult') }}</h3>
        </div>
        <p class="mt-4">
          {{ $t('thereAreZBons', { length: zbonList.length }) }}
        </p>
        <div class="mt-4">
          <div
            v-for="z in zbonList"
            :key="z.zbonNumber"
            class="d-flex align-center"
          >
            <v-simple-checkbox
              :value="selectedZBonIdList.includes(z.zbonNumber)"
              @click="toggle(z.zbonNumber)"
            />
            <div class="text-body-1">
              {{ z.zbonNumber }}
            </div>
            <v-spacer />
            <div class="text-body-1">
              <v-icon left>
                mdi-clock-outline
              </v-icon>
              {{ z.toTimestamp |beautifulTime }}
            </div>
          </div>
        </div>
        <send-to-email-button
          v-if="zbonUseType === 2"
          :disabled="selectedZBonIdList.length===0"
          :loading="loading"
          class="mt-4"
          @click="outputPdf"
        />
        <v-btn
          v-if="zbonUseType === 1"
          :disabled="selectedZBonIdList.length===0"
          :loading="loading"
          block
          class="mt-2"
          color="info"
          elevation="0"
          @click="reprintZbon"
        >
          {{ $t('reprint') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import DatePickerInput from '@/views/AadenPages/dashboard/components/DatePickerInput.vue'
import { defaultDate } from '@/model/dataLayer/api/common/DateRepository'
import IKUtils from 'innerken-js-utils'
import {
  exportNewCSVFromTo,
  isBlank,
  newGetZBon,
  newNewPrintZbon,
  newPrintZBon,
  printSummaryBon,
  sendCsvToEmail,
  sendSummaryBon
} from '@/model/dataLayer/service/otherService'
import { emptyOrIncludes, showSuccessMessage } from '@/model/utils/utils'
import i18n from '@/i18n'
import dayjs from 'dayjs'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import GlobalConfig, { Remember } from '@/model/global/GlobalSettings'
import DishStatistic from '@/model/dataLayer/api/export/DishStatistic'
import Category from '@/model/dataLayer/api/dish/Category'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import Attribute from '@/model/dataLayer/api/dish/Attribute'
import SendToEmailButton from '@/views/AadenPages/components/SendToEmailButton.vue'
import { expertPaymentStatisticCsv, exportDishStatisticCsv } from '@/model/dataLayer/service/newExport'
import { printDailyCardTerminal } from '@/model/dataLayer/api/bills/CardTerminal'

export default {
  components: {
    SendToEmailButton,
    DatePickerInput,
    PageHeader
  },
  data: function () {
    return {
      zbonUseType: 0,
      loading: false,
      selectedZbonDialog: false,
      btnLoading: false,
      dishStatisticLoading: false,
      dishStatisticPrintOrSendEmail: '',
      dishStatisticList: [],
      model: DishStatistic,
      CategoryModel: Category,
      CategoryTypeModel: CategoryType,
      AttributeModel: Attribute,
      dishCategoryList: [],
      dishCategoryTypeList: [],
      hideAttributeList: [],
      selectFilter: {
        selectCategoryIds: [],
        selectCategoryTypeIds: [],
        selectHideAttributeIds: []
      },
      selectedDish: false,
      selectedZBonIdList: [],
      zbonList: [],
      dateRange: [defaultDate, defaultDate],
      items: [
        {
          id: 1,
          value: 'totalOrders',
          desc: this.$t('ExportPageHint'),
          sendEmail: true,
          download: false,
          reprint: true
        },
        {
          id: 2,
          value: 'ZBon',
          desc: this.$t('ExportPageHint1'),
          sendEmail: true,
          download: false,
          reprint: true
        },
        {
          id: 3,
          value: 'gdpduCsv',
          desc: this.$t('ExportPageHint2'),
          sendEmail: true,
          download: true,
          reprint: false
        },
        {
          id: 4,
          value: 'salesBon',
          desc: this.$t('ExportPageHint3'),
          sendEmail: true,
          download: false,
          reprint: true
        },
        {
          id: 5,
          value: 'PaymentRecord',
          desc: '',
          sendEmail: false,
          download: true,
          reprint: false
        },
        {
          id: 6,
          value: 'SalesRecord',
          desc: '',
          sendEmail: false,
          download: true,
          reprint: false
        },
        {
          id: 7,
          value: 'CardDailyTerminal',
          desc: '',
          sendEmail: false,
          download: false,
          reprint: true
        }
      ],
      tab: null
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'overrideCardTerminalIp',
          name: 'CardTerminalIP',
          required: false,
          default: Remember.cardTerminalIP
        },
        {
          key: 'overrideCardTerminalPort',
          name: 'CardTerminalPort',
          required: false,
          default: Remember.cardTerminalPort
        }
      ]
    },
    filterDishStatisticList () {
      if (this.selectFilterIsBlank) {
        return this.dishStatisticList
      } else {
        console.log(this.dishStatisticList, this.selectFilter.selectCategoryTypeIds)
        return this.dishStatisticList
          .filter(item =>
            emptyOrIncludes(this.selectFilter.selectCategoryIds, parseInt(item.categoryId)) &&
              emptyOrIncludes(this.selectFilter.selectCategoryTypeIds, parseInt(item.categoryTypeId))
          ) ?? []
      }
    },
    selectFilterIsBlank () {
      return Object.entries(this.selectFilter).every(i => isBlank(i[1]))
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler (val) {
        if (val) {
          this.loadZBonList()
          this.loadGDPuCsvList()
        }
      },
      deep: true
    }
  },
  async mounted () {
    this.dishCategoryList = await this.CategoryModel.getList(true)
    this.dishCategoryTypeList = await this.CategoryTypeModel.getList(true)
    console.log(this.dishCategoryTypeList, 'list')
    this.hideAttributeList = await this.AttributeModel.getList(true)
  },
  methods: {
    async outputPdf () {
      this.loading = true
      // await this.showLoading('ZBon')
      try {
        if (this.selectedZBonIdList.length < 2) {
          await newPrintZBon(this.selectedZBonIdList[0], 1, 1)
        } else {
          await newNewPrintZbon(this.selectedZBonIdList)
        }
      } catch (e) {

      }
      // await this.hideLoading()
      this.loading = false
      showSuccessMessage(this.$t('submit_success'))
      this.selectedZbonDialog = false
    },
    async reprintZbon () {
      this.loading = true
      try {
        for (const i of this.selectedZBonIdList) {
          await newPrintZBon(i)
        }
      } catch (e) {

      }
      this.loading = false
      showSuccessMessage(this.$t('print_success'))
      this.selectedZbonDialog = false
    },
    toggle (id) {
      if (this.selectedZBonIdList.includes(id)) {
        this.selectedZBonIdList = this.selectedZBonIdList.filter(it => it !== id)
      } else {
        this.selectedZBonIdList.push(id)
      }
    },
    async printOrSendMail (op) {
      this.dishStatisticLoading = true

      const filter = [
        this.selectFilter.selectCategoryIds?.toString(),
        this.selectFilter.selectCategoryTypeIds?.toString(),
        this.selectFilter.selectHideAttributeIds?.toString()
      ]

      try {
        if (op === 'print') {
          await this.model.printOrSendMail('printSalesBon', this.dateRange, ...filter)
        } else if (op === 'printWithCode') {
          await this.model.printOrSendMail('printSalesBonByDishCode', this.dateRange, ...filter)
        } else {
          await this.model.printOrSendMail('sendSalesBonEmail', this.dateRange, ...filter)
        }
      } catch (e) {
        IKUtils.showError(e)
      }
      this.btnLoading = false
      this.dishStatisticLoading = false
      this.selectedDish = false
    },
    handleClear () {
      this.selectFilter = {
        selectCategoryIds: [],
        selectCategoryTypeIds: [],
        selectHideAttributeIds: []
      }
    },
    async loadGDPuCsvList () {
      this.dishStatisticList = await this.model.load(...this.dateRange)
    },
    async loadZBonList () {
      const fromTime = this.dateRange[0] + ' 04:00:00'
      const toTime = dayjs(this.dateRange[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59'
      const detailTime = [fromTime, toTime]
      this.zbonList = (await newGetZBon(detailTime))
      this.selectedZBonIdList = this.zbonList.map(it => it.zbonNumber)
    },
    async reprint (item) {
      this.btnLoading = true
      if (item.id === 1) {
        IKUtils.showLoading()
        const timeSpan = { timespan: this.dateRange.join(' - ') }
        try {
          await printSummaryBon(timeSpan)
          showSuccessMessage(i18n.t('print_success'))
        } catch (e) {

        }
      } else if (item.id === 2) {
        this.zbonUseType = 1
        this.selectedZbonDialog = true
        // try {
        //   for (const i of this.selectedZBonIdList) {
        //     await newPrintZBon(i)
        //   }
        // } catch (e) {
        //
        // }
      } else if (item.id === 4) {
        this.dishStatisticPrintOrSendEmail = 'print'
        this.selectedDish = true
      } else if (item.id === 7) {
        await printDailyCardTerminal()
        showSuccessMessage(i18n.t('print_success'))
      }
      this.btnLoading = false
    },
    async sendEmail (item) {
      this.btnLoading = true
      if (item.id === 1) {
        IKUtils.showLoading()
        const timeSpan = { timespan: this.dateRange.join(' - ') }
        try {
          await sendSummaryBon(timeSpan)
          showSuccessMessage(i18n.t('print_success'))
        } catch (e) {

        }
      } else if (item.id === 2) {
        this.zbonUseType = 2
        this.selectedZbonDialog = true
      } else if (item.id === 3) {
        await sendCsvToEmail(
          this.dateRange[0] + ' 04:00:00',
          dayjs(this.dateRange[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59'
        )
      } else if (item.id === 4) {
        this.dishStatisticPrintOrSendEmail = 'send'
        this.selectedDish = true
      }
      this.btnLoading = false
    },
    async download (item) {
      this.btnLoading = true
      if (item.id === 3) {
        const data = await exportNewCSVFromTo({
          fromTime: this.dateRange[0] + ' 04:00:00',
          toTime: dayjs(this.dateRange[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59'
        })
        const res = data.split('..')[1]
        const { url } = await getBaseAndUrlForDeviceId(GlobalConfig.DeviceId)
        await window.open(url + res)
      } else if (item.id === 5) {
        const data = await expertPaymentStatisticCsv(...this.dateRange)
        const content = new Blob([data], { type: 'text/csv' })
        const urlObj = window.URL
        const url = urlObj.createObjectURL(content)
        this.$refs.downloadfile.href = url
        this.$refs.downloadfile.acceptCharset = 'UTF-8'
        this.$refs.downloadfile.click()
        urlObj.revokeObjectURL(url)
      } else if (item.id === 6) {
        const data = await exportDishStatisticCsv(...this.dateRange)
        const content = new Blob([data], { type: 'text/csv' })
        const urlObj = window.URL
        const url = urlObj.createObjectURL(content)
        this.$refs.downloadfile.href = url
        this.$refs.downloadfile.acceptCharset = 'UTF-8'
        this.$refs.downloadfile.click()
        urlObj.revokeObjectURL(url)
      }
      this.btnLoading = false
    }
  }
}
</script>

<style scoped>

</style>
